module.exports = __webpack_public_path__ + "static/lady-sitting-mobile-921dc26f655c82c310e1036a1671b26f.png";